import React, { useState, useEffect } from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import ReactDOM from 'react-dom';
import styled from 'styled-px2vw';

const Wrapper = styled(TransitionGroup)`
  padding-top: 140px;
  .message {
    padding: 0 24px;
    height: 60px;
    background: #2c323f;
    box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.5);
    border-radius: 8px;
    pointer-events: none;
    svg {
      margin-right: 8px;
      width: 26px;
      height: 26px;
    }
    p {
      white-space: nowrap;
      font-size: 20px;
      font-weight: 400;
      color: #f0f7ff;
    }
  }
  .message + .message {
    margin-top: 14px;
  }
  .slide-in-top-enter {
    opacity: 0;
    transform: translate(0, -100%);
  }
  .slide-in-top-enter-active {
    opacity: 1;
    transform: translate(0);
    transition: transform 200ms ease-out, opacity 200ms ease-in-out;
  }
  .slide-in-top-exit {
    opacity: 1;
  }
  .slide-in-top-exit-active {
    opacity: 0;
    transform: translate(0, -100%);
    transition: transform 300ms linear 100ms, opacity 300ms ease-in-out;
  }
`;

const IconInfo = (props) => (
  <svg viewBox="0 0 1097 1024" width="256" height="256" fill="currentColor" {...props}>
    <path d="M548.571429 0c283.574857 0 512 228.425143 512 512s-228.425143 512-512 512-512-228.425143-512-512 228.425143-512 512-512z m0 78.701714C312.246857 78.701714 115.346286 275.748571 115.346286 512c0 236.251429 196.900571 433.225143 433.225143 433.225143 236.251429 0 433.225143-196.973714 433.225142-433.225143 0-236.324571-196.973714-433.298286-433.225142-433.298286zM559.542857 416.914286a54.857143 54.857143 0 0 1 54.857143 54.857143v292.571428a54.857143 54.857143 0 0 1-109.714286 0v-292.571428a54.857143 54.857143 0 0 1 54.857143-54.857143z m0-197.485715a54.857143 54.857143 0 1 1 0 109.714286 54.857143 54.857143 0 0 1 0-109.714286z"></path>
  </svg>
);

const IconSuccess = (props) => (
  <svg viewBox="0 0 1097 1024" width="256" height="256" fill="currentColor" {...props}>
    <path d="M548.571429 0c283.574857 0 512 228.425143 512 512s-228.425143 512-512 512-512-228.425143-512-512 228.425143-512 512-512z m0 78.701714C312.246857 78.701714 115.346286 275.748571 115.346286 512c0 236.251429 196.900571 433.225143 433.225143 433.225143 236.251429 0 433.225143-196.973714 433.225142-433.225143 0-236.324571-196.973714-433.298286-433.225142-433.298286z m141.750857 291.474286a38.034286 38.034286 0 0 1 55.149714 0 37.888 37.888 0 0 1 4.681143 49.590857l-4.681143 5.558857L517.12 653.750857a37.888 37.888 0 0 1-49.590857 4.681143l-5.558857-4.681143L351.670857 543.451429c-15.798857-15.725714-15.798857-47.250286 0-62.976a68.169143 68.169143 0 0 1 46.665143-3.291429l8.411429 3.291429 86.674285 86.601142 196.900572-196.900571z"></path>
  </svg>
);

const IconError = (props) => (
  <svg viewBox="0 0 1096 1024" width="256" height="256" fill="currentColor" {...props}>
    <path d="M909.806496 150.269341a510.514713 510.514713 0 0 1 0 723.460587 510.514713 510.514713 0 0 1-723.460587 0 510.514713 510.514713 0 0 1 0-723.460587 510.514713 510.514713 0 0 1 723.460587 0z m-667.849122 55.611465c-166.907473 166.98055-166.907473 445.18403 0 612.16458 166.98055 166.907473 445.18403 166.907473 612.16458 0 166.907473-166.98055 166.907473-445.18403 0-612.16458C687.141404 38.973333 408.937924 38.973333 241.884297 205.880806z m207.538189 141.695968l98.653716 98.653716 98.653717-98.653716a46.476862 46.476862 0 0 1 65.769144 65.769144L613.845347 511.999635l98.653716 98.653716a46.476862 46.476862 0 0 1-65.769144 65.769144L548.076203 577.768779l-98.653717 98.653716a46.476862 46.476862 0 0 1-65.769144-65.769144l98.653716-98.653716-98.653716-98.653717a46.476862 46.476862 0 1 1 65.769144-65.769144z"></path>
  </svg>
);

const IconWarning = (props) => (
  <svg viewBox="0 0 1097 1024" width="256" height="256" fill="currentColor" {...props}>
    <path d="M548.571429 0c283.574857 0 512 228.425143 512 512s-228.425143 512-512 512-512-228.425143-512-512 228.425143-512 512-512z m0 78.701714C312.246857 78.701714 115.346286 275.748571 115.346286 512c0 236.251429 196.900571 433.225143 433.225143 433.225143 236.251429 0 433.225143-196.973714 433.225142-433.225143 0-236.324571-196.973714-433.298286-433.225142-433.298286zM559.542857 709.485714a54.857143 54.857143 0 1 1 0 109.714286 54.857143 54.857143 0 0 1 0-109.714286z m0-490.057143a54.857143 54.857143 0 0 1 54.857143 54.857143v292.571429a54.857143 54.857143 0 1 1-109.714286 0v-292.571429A54.857143 54.857143 0 0 1 559.542857 219.428571z"></path>
  </svg>
);

const IconMap = {
  info: <IconInfo color="#1683ff" />,
  success: <IconSuccess color="#00ba3d" />,
  warning: <IconWarning color="#faa800" />,
  error: <IconError color="#dc445d" />,
};

let key = 1;
let add = () => {};

function getKey() {
  return key++;
}

function Inner() {
  const timeout = 3000;
  const maxCount = 6;
  const [notices, setNotices] = useState([]);

  const remove = (notice) => {
    const { key } = notice;
    setNotices((prevNotices) => prevNotices.filter(({ key: itemKey }) => key !== itemKey));
  };

  add = (notice) => {
    setNotices((prevNotices) => [...prevNotices, notice]);
    setTimeout(() => {
      remove(notice);
    }, timeout);
  };

  useEffect(() => {
    if (notices.length > maxCount) {
      const [firstNotice] = notices;
      remove(firstNotice);
    }
  }, [notices]);

  // notices.length > 0 &&
  return (
    <Wrapper className="col-center">
      {notices.map((ele) => (
        <CSSTransition in timeout={200} classNames="slide-in-top" key={ele.key}>
          <div className="message row-center">
            {IconMap[ele.type]}
            <p>{ele.text}</p>
          </div>
        </CSSTransition>
      ))}
    </Wrapper>
  );
}

ReactDOM.render(<Inner />, document.getElementById('modal-root'));

const Message = {
  info: (text) => add({ text, key: getKey(), type: 'info' }),
  success: (text) => add({ text, key: getKey(), type: 'success' }),
  warning: (text) => add({ text, key: getKey(), type: 'warning' }),
  error: (text) => add({ text, key: getKey(), type: 'error' }),
};

export default Message;
